import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import AssignTopicsTable from "./components/AssignTopicsTable";

const AssignTopics = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>Assign Topics</PageHeading>
      <AssignTopicsTable />
    </>
  );
};

export default AssignTopics;
